import axiosOverlay from "../../js/axiosOverlay";

const state = {
    moyenAcces: null
};

const getters = {
    moyenAcces: state => state.moyenAcces,
    getCouleurByType: (state) => (type) => {
        let filteredByType = state.moyenAcces.filter(ma => ma.type == type);
        if (!filteredByType.find(ma => ma.couleur != null))
            return null;
        else
            return filteredByType.map(ma => ma.couleur);
    },
    getMoyenAcces: (state) => {
        return state.moyenAcces;
    },
    getMoyenAccesByTypeAndCouleur: (state) => (type, couleur) => {
        return state.moyenAcces.find(ma => ma.type == type && ma.couleur == couleur);
    },
    getMoyenAccesByType: (state) => (type) => {
        return state.moyenAcces.find(ma => ma.type == type);
    }
};

const mutations = {
    SET_MOYEN_ACCES(state, moyenAcces) {
        state.moyenAcces = moyenAcces;
    }
};

const actions = {
    async loadMoyenAccesFromAPI({ commit, state }) {
        if (!state.moyenAcces) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + '/crc_moyen_acces'
            };

            const response = await axiosOverlay(config);
            commit('SET_MOYEN_ACCES', response.data);
            return true;
        } else {
            return true;
        }
    },
    
    async facturerMoyenAcces({ rootGetters }, { ctct, cnct, totalCost, date, comment, rclexe, rclnum, rclnlig }) {
        let data = JSON.stringify({
            'cnct': cnct,
            'ctct': ctct,
            'totalCost': totalCost,
            'comment': comment,
            'date': date,
            'pec': parseInt(rootGetters['user/getCodePec']),
            'rclexe': parseInt(rclexe),
            'rclnum': parseInt(rclnum),
            'rclnlig': parseInt(rclnlig),
        });
        
        let config = {
            method: 'post',
            url: process.env.VUE_APP_API_URL + '/facturer_moyenacces',
            data: data
        };

        try {
            const response = await axiosOverlay(config);
            return response.data;
        } catch (error) {
            console.log(error.response);
            throw error.response.data.error;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
